import { createFileRoute } from '@tanstack/react-router';

import { AuthRouteLayout } from '@/components/layout/AuthLayout/AuthRouteLayout';

export const Route = createFileRoute('/_auth')({
  component: AuthRouteLayout,
});
